// Admin form validation messages (Indonesian), used by the shared Zod schemas.
export const VALIDATION_MESSAGES = {
  slugFormat: "Gunakan huruf kecil, angka, dan tanda hubung",
  specialPriceBelowNormal: "Harga spesial harus lebih kecil dari harga normal",
  contentSourceRequired: "Link wajib punya URL; tipe lain wajib punya file",
  couponCodeFormat: "Hanya huruf, angka, _ dan -",
  percentageMax: "Diskon persen maksimal 100",
  endAfterStart: "Tanggal berakhir harus setelah tanggal mulai",
  reasonRequired: "Tuliskan alasan (min. 5 karakter)",
  unsupportedFileType: "Tipe file tidak didukung",
  fileTooLarge: "Ukuran file terlalu besar",
  authorRequired: "Pilih author produk ini",
  urlFormat: "Masukkan URL lengkap yang diawali https://",
  youTubeUrl: "Masukkan link video YouTube, mis. https://youtu.be/…",
} as const;
